<script lang="ts" setup>
	import type { DefaultOptionType, SelectValue } from 'ant-design-vue/es/select'
	const { required = true } = defineProps<{ required?: boolean }>()
	const formData = defineModel<string | null>({ default: null })
	const { businessTypes } = useStore()
	const emit = defineEmits<{ selected: [value: SelectOptionContext[number]] }>()

	const handleSelectChange = (value: SelectValue) => {
		const selected = businessTypes.find(item => item.value === value)
		if (!selected) return
		emit('selected', selected)
	}
</script>
<template>
	<a-form-item label="Business Type" :required name="business_type" class="!mb-5">
		<a-select
			v-model:value="formData as string"
			:options="businessTypes as DefaultOptionType[]"
			placeholder="Select your business type"
			class="w-full"
			data-testid="business_sector"
			show-search
			allow-clear
			@change="handleSelectChange"
		/>
	</a-form-item>
</template>
